(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["circular-parallax"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  if (window.NichaPortfolioWheelV2) {
    window.NichaPortfolioWheelV2.refresh();
    return;
  }

  var entries = [];
  var groups = [];
  var parents = [];
  var frame = 0;
  var rebuild = true;
  var keyboard = false;
  var visualScroll = null;
  var lastTime = 0;
  var motionEnabled = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var css = document.createElement('style');

  css.textContent =
    '.gw-stage{isolation:isolate;}' +
    '.gw-section{position:relative;z-index:var(--gw-order,0);}' +
    '.gw-slot{position:relative;display:flow-root;overflow:visible;perspective:var(--gw-distance,none);perspective-origin:var(--gw-origin,50% 50%);}' +
    '.gw-panel{transform-origin:50% 50%;transform:var(--gw-transform,none);opacity:var(--gw-opacity,1);pointer-events:var(--gw-pointer,auto);backface-visibility:hidden;transition:none!important;}' +
    '.gw-curve{position:absolute;display:none;pointer-events:none;transform:none!important;overflow:visible;}' +
    '.gw-bent>.gw-panel{opacity:0!important;pointer-events:none!important;}' +
    '.gw-bent>.gw-curve{display:block;}' +
    '.gw-strip{position:absolute;top:0;left:0;overflow:hidden;transform-origin:0 0;backface-visibility:hidden;}' +
    '.gw-copy{position:absolute!important;left:0!important;margin:0!important;max-width:none!important;box-shadow:none!important;transform:none!important;opacity:1!important;}' +
    '@media(prefers-reduced-motion:reduce){.gw-slot{perspective:none!important;}.gw-slot>.gw-panel{transform:none!important;opacity:1!important;pointer-events:auto!important;}.gw-slot>.gw-curve{display:none!important;}}' +
    '@media print{.gw-slot{perspective:none!important;}.gw-slot>.gw-panel{transform:none!important;opacity:1!important;pointer-events:auto!important;}.gw-slot>.gw-curve{display:none!important;}}';

  document.head.appendChild(css);

  function schedule() {
    if (!frame && !document.hidden) {
      frame = window.requestAnimationFrame(paint);
    }
  }

  function refresh() {
    rebuild = true;
    visualScroll = null;

    entries.forEach(function (entry) {
      entry.measure = true;
      entry.dirty = true;
    });

    schedule();
  }

  function setBent(entry, bent) {
    if (entry.bent === bent) return;
    entry.bent = bent;
    entry.slot.classList.toggle('gw-bent', bent);
  }

  function clearCurve(entry) {
    if (!entry.curve || !entry.bands.length) return;

    entry.curve.textContent = '';
    entry.bands = [];
    entry.curveImages = [];
    entry.curveReady = false;
  }

  function reset(entry) {
    setBent(entry, false);
    clearCurve(entry);

    if (entry.mode === 'static') return;
    entry.mode = 'static';

    entry.source.style.removeProperty('--gw-transform');
    entry.source.style.removeProperty('--gw-opacity');
    entry.source.style.removeProperty('--gw-pointer');
    entry.slot.style.removeProperty('--gw-distance');
    entry.slot.style.removeProperty('--gw-origin');
    entry.section.style.removeProperty('--gw-order');
  }

  function remove(entry) {
    reset(entry);

    if (entry.curve) entry.curve.remove();
    entry.source.classList.remove('gw-panel');
    entry.section.classList.remove('gw-section');

    if (entry.observer) entry.observer.disconnect();

    if (entry.slot.parentNode) {
      entry.slot.parentNode.insertBefore(entry.source, entry.slot);
      entry.slot.remove();
    }
  }

  function add(source, section, group, photo) {
    var entry = null;

    entries.some(function (item) {
      if (item.source === source) {
        entry = item;
        return true;
      }
      return false;
    });

    if (!entry) {
      var slot = document.createElement('div');
      slot.className = 'gw-slot';

      source.parentNode.insertBefore(slot, source);
      slot.appendChild(source);
      source.classList.add('gw-panel');
      section.classList.add('gw-section');

      entry = {
        source: source,
        slot: slot,
        section: section,
        bands: [],
        dirty: true,
        measure: true,
        bent: false,
        images: Array.from(source.querySelectorAll('img'))
      };

      if (photo) {
        entry.curve = document.createElement('div');
        entry.curve.className = 'gw-curve';
        entry.curve.setAttribute('aria-hidden', 'true');

        entry.curve.addEventListener('load', function () {
          if (
            !entry.curveReady &&
            entry.curveImages &&
            entry.curveImages.every(imageReady)
          ) {
            entry.curveReady = true;
            schedule();
          }
        }, true);

        slot.appendChild(entry.curve);
      }

      if (window.ResizeObserver) {
        entry.observer = new ResizeObserver(function () {
          entry.measure = true;
          schedule();
        });

        entry.observer.observe(source);
      }

      entries.push(entry);
    }

    entry.group = group;
    entry.photo = photo;
    entry.kept = true;
    group.entries.push(entry);
  }

  function collect() {
    rebuild = false;

    entries.forEach(function (entry) {
      entry.kept = false;
    });

    parents.forEach(function (parent) {
      parent.classList.remove('gw-stage');
    });

    parents = [];
    groups = [];

    document.querySelectorAll('[data-common-roll-photo]').forEach(function (photo) {
      var section = photo.closest('.shopify-section');

      if (section && parents.indexOf(section.parentNode) === -1) {
        parents.push(section.parentNode);
      }
    });

    parents.forEach(function (parent) {
      parent.classList.add('gw-stage');

      var group = null;
      var leading = [];

      Array.prototype.forEach.call(parent.children, function (section) {
        var photo = section.querySelector('[data-common-roll-photo]');
        var text = section.querySelector('[id^="TextButton-"] .tb-inner');

        if (photo) {
          if (!group) {
            var bendValue = photo.getAttribute('data-bend-strength');

            group = {
              entries: [],
              strength: Math.max(
                0,
                Math.min(12, Number(photo.getAttribute('data-roll-strength')) || 0)
              ),
              mobile: photo.getAttribute('data-roll-mobile') !== 'false',
              mobileSize: Math.max(
                70,
                Math.min(120, Number(photo.getAttribute('data-mobile-wheel-size')) || 85)
              ) / 100,
              bend: bendValue === null
                ? 4
                : Math.max(0, Math.min(8, Number(bendValue) || 0))
            };

            groups.push(group);

            leading.forEach(function (item) {
              add(item.source, item.section, group, false);
            });

            leading = [];
          }

          var source = photo.querySelector('.cr-face');

          if (source) add(source, section, group, true);
        } else if (text) {
          if (group) {
            add(text, section, group, false);
          } else {
            leading.push({ source: text, section: section });
          }
        } else if (section.getBoundingClientRect().height > 0) {
          group = null;
          leading = [];
        }
      });
    });

    entries.slice().forEach(function (entry) {
      if (!entry.kept || !entry.source.isConnected) {
        remove(entry);
        entries.splice(entries.indexOf(entry), 1);
      }
    });
  }

  function wheelPose(offset, radius) {
    var angle = offset / radius;

    return {
      angle: angle,
      y: radius * Math.sin(angle),
      z: radius * (Math.cos(angle) - 1),
      tilt: -angle * 180 / Math.PI
    };
  }

  function smooth(value) {
    value = Math.max(0, Math.min(1, value));
    return value * value * (3 - 2 * value);
  }

  function bendAt(angle, strength, mobile) {
    return strength * 0.025 * (mobile ? 0.70 : 1) *
      smooth((Math.abs(angle) - 0.12) / 0.70);
  }

  function surfaceRow(row, photoHeight, bend, angle, radius) {
    var localY = row - photoHeight / 2;
    var localZ = 0;

    if (bend > 0.000001) {
      var curveRadius = photoHeight / (2 * bend);
      localZ = curveRadius * (Math.cos(localY / curveRadius) - 1);
      localY = curveRadius * Math.sin(localY / curveRadius);
    }

    var c = Math.cos(angle);
    var s = Math.sin(angle);
    var y = radius * s + c * localY + s * localZ;
    var z = radius * (c - 1) - s * localY + c * localZ;
    var scale = radius * 4 / (radius * 4 - z);

    return { y: y * scale, scale: scale };
  }

  function curveMatrix(
    top, left, photoHeight, offset, length,
    viewHeight, viewWidth, bend, angle, radius
  ) {
    var a = surfaceRow(offset, photoHeight, bend, angle, radius);
    var b = surfaceRow(offset + length, photoHeight, bend, angle, radius);
    var g = (a.scale / b.scale - 1) / length;
    var x0 = (viewWidth / 2 - left) * (1 - a.scale);
    var x1 = (viewWidth / 2 - left) * (1 - b.scale);
    var y0 = viewHeight / 2 + a.y - top;
    var y1 = viewHeight / 2 + b.y - top;
    var k = 1 + g * length;

    return [
      a.scale, 0, 0, 0,
      (x1 * k - x0) / length,
      (y1 * k - y0) / length,
      0, g,
      0, 0, 1, 0,
      x0, y0, 0, 1
    ];
  }

  function imageReady(img) {
    return img.complete && img.naturalWidth > 0;
  }

  function buildCurve(entry, width, height, mobile) {
    clearCurve(entry);

    entry.curveWidth = width;
    entry.curveHeight = height;
    entry.dirty = false;

    var template = entry.source.cloneNode(true);
    template.classList.remove('gw-panel');
    template.classList.add('gw-copy');
    template.removeAttribute('id');
    template.style.width = width + 'px';
    template.style.height = height + 'px';

    template.querySelectorAll('[id]').forEach(function (node) {
      node.removeAttribute('id');
    });

    template.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (node) {
      node.setAttribute('tabindex', '-1');
    });

    template.querySelectorAll('img').forEach(function (img, index) {
      var original = entry.images[index];

      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.removeAttribute('loading');
      img.removeAttribute('fetchpriority');

      if (original && original.currentSrc) {
        img.src = original.currentSrc;
      }

      img.alt = '';
    });

    var fragment = document.createDocumentFragment();
    var count = mobile ? 24 : 36;
    var step = height / count;

    entry.curveMobile = mobile;

    for (var index = 0; index < count; index++) {
      var offset = index * step;
      var length = Math.min(step + 0.75, height - offset);
      var strip = document.createElement('div');

      strip.className = 'gw-strip';
      strip.style.width = width + 'px';
      strip.style.height = length + 'px';

      var copy = template.cloneNode(true);
      copy.style.top = -offset + 'px';

      strip.appendChild(copy);
      fragment.appendChild(strip);

      entry.bands.push({
        node: strip,
        offset: offset,
        length: length
      });
    }

    entry.curve.appendChild(fragment);
    entry.curveImages = Array.from(entry.curve.querySelectorAll('img'));
    entry.curveReady = entry.curveImages.every(imageReady);
  }

  function paint(now) {
    frame = 0;

    if (document.hidden) return;
    if (rebuild) collect();

    var height = window.innerHeight;
    var width = document.documentElement.clientWidth;
    var mobile = width < 750;
    var scroll = window.scrollY || window.pageYOffset || 0;

    now = typeof now === 'number' ? now : Date.now();

    var dt = lastTime
      ? Math.min(40, Math.max(1, now - lastTime))
      : 16;

    lastTime = now;

    if (reduced.matches || keyboard || !height || !width) {
      visualScroll = scroll;
      motionEnabled = false;
      entries.forEach(reset);
      return;
    }

    if (visualScroll === null || Math.abs(scroll - visualScroll) > height) {
      visualScroll = scroll;
    }

    visualScroll += (scroll - visualScroll) *
      (1 - Math.exp(-dt / (mobile ? 45 : 60)));

    if (Math.abs(scroll - visualScroll) < 0.15) {
      visualScroll = scroll;
    }

    var correction = scroll - visualScroll;

    groups.forEach(function (group) {
      group.enabled = group.strength > 0 && (!mobile || group.mobile);
      group.radius = height *
        (1.15 - group.strength * 0.06 + (mobile ? 0.20 : 0));

      if (mobile) group.radius *= group.mobileSize;
    });

    motionEnabled = groups.some(function (group) {
      return group.enabled;
    });

    var readings = entries.map(function (entry) {
      if (!entry.group.enabled) return { entry: entry };

      var box = entry.slot.getBoundingClientRect();

      if (entry.measure || !entry.metrics || !entry.observer) {
        entry.metrics = {
          top: entry.source.offsetTop,
          left: entry.source.offsetLeft,
          height: entry.source.offsetHeight,
          width: entry.source.offsetWidth
        };

        entry.measure = false;
      }

      return {
        entry: entry,
        box: box,
        top: box.top + entry.metrics.top,
        left: box.left + entry.metrics.left,
        height: entry.metrics.height,
        width: entry.metrics.width
      };
    });

    readings.forEach(function (reading) {
      if (reading.height) {
        reading.entry.group.radius = Math.max(
          reading.entry.group.radius,
          reading.height * 0.95
        );
      }
    });

    readings.forEach(function (reading) {
      var entry = reading.entry;
      var group = entry.group;

      if (!group.enabled || !reading.width || !reading.height) {
        reset(entry);
        return;
      }

      var rawOffset = reading.top + reading.height / 2 - height / 2;
      var offset = rawOffset + correction;
      var pose = wheelPose(offset, group.radius);
      var turn = Math.abs(pose.angle);

      if (turn >= 1.36) {
        if (entry.mode === 'hidden') return;

        entry.mode = 'hidden';
        setBent(entry, false);

        entry.source.style.setProperty('--gw-opacity', '0');
        entry.source.style.setProperty('--gw-pointer', 'none');
        entry.source.style.removeProperty('--gw-transform');
        entry.slot.style.removeProperty('--gw-distance');
        entry.section.style.setProperty('--gw-order', '0');

        clearCurve(entry);
        return;
      }

      entry.mode = 'visible';

      var fade = Math.max(0, Math.min(1, (turn - 1.10) / 0.26));
      var opacity = 1 - fade * fade * (3 - 2 * fade);

      entry.slot.style.setProperty(
        '--gw-distance',
        (group.radius * 4) + 'px'
      );

      entry.slot.style.setProperty(
        '--gw-origin',
        (width / 2 - reading.box.left) + 'px ' +
        (height / 2 - reading.box.top) + 'px'
      );

      entry.source.style.setProperty('--gw-opacity', String(opacity));

      entry.source.style.setProperty(
        '--gw-pointer',
        opacity < 0.15 ? 'none' : 'auto'
      );

      entry.source.style.setProperty(
        '--gw-transform',
        Math.abs(offset) < 0.01 && Math.abs(rawOffset) < 0.01
          ? 'none'
          : 'translate3d(0,' +
            (pose.y - rawOffset).toFixed(4) + 'px,' +
            pose.z.toFixed(4) + 'px) rotateX(' +
            pose.tilt.toFixed(5) + 'deg)'
      );

      entry.section.style.setProperty(
        '--gw-order',
        String(1 + Math.round(30 * Math.cos(pose.angle)))
      );

      var bend = entry.photo
        ? bendAt(pose.angle, group.bend, mobile)
        : 0;

      if (
        bend < 0.00001 ||
        !entry.curve ||
        !entry.images.length ||
        !entry.images.every(imageReady)
      ) {
        setBent(entry, false);
        return;
      }

      if (
        entry.dirty ||
        !entry.bands.length ||
        entry.curveWidth !== reading.width ||
        entry.curveHeight !== reading.height ||
        entry.curveMobile !== mobile
      ) {
        buildCurve(entry, reading.width, reading.height, mobile);
      }

      if (!entry.curveReady) {
        entry.curveReady = entry.curveImages.every(imageReady);

        if (!entry.curveReady) {
          setBent(entry, false);
          return;
        }
      }

      entry.curve.style.left = (reading.left - reading.box.left) + 'px';
      entry.curve.style.top = (reading.top - reading.box.top) + 'px';
      entry.curve.style.width = reading.width + 'px';
      entry.curve.style.height = reading.height + 'px';
      entry.curve.style.opacity = String(opacity);

      entry.bands.forEach(function (band) {
        var matrix = curveMatrix(
          reading.top,
          reading.left,
          reading.height,
          band.offset,
          band.length,
          height,
          width,
          bend,
          pose.angle,
          group.radius
        );

        band.node.style.transform = 'matrix3d(' + matrix.join(',') + ')';
      });

      setBent(entry, true);
    });

    if (correction && motionEnabled) schedule();
  }

  window.NichaPortfolioWheelV2 = { refresh: refresh };

  window.addEventListener('scroll', function () {
    if (motionEnabled) schedule();
  }, { passive: true });

  window.addEventListener('resize', refresh, { passive: true });

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('shopify:section:select', refresh);

  document.addEventListener('load', function (event) {
    if (
      event.target.tagName === 'IMG' &&
      !event.target.closest('.gw-curve')
    ) {
      var affected = false;

      entries.forEach(function (entry) {
        if (entry.source.contains(event.target)) {
          entry.dirty = true;
          entry.measure = true;
          affected = true;
        }
      });

      if (affected) schedule();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') {
      keyboard = true;
      motionEnabled = false;
      entries.forEach(reset);
      schedule();
    }
  });

  document.addEventListener('pointerdown', function () {
    keyboard = false;
    schedule();
  });

  document.addEventListener('focusin', schedule);

  if (reduced.addEventListener) {
    reduced.addEventListener('change', schedule);
  } else {
    reduced.addListener(schedule);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
    } else {
      visualScroll = null;
      lastTime = 0;
      schedule();
    }
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('horizontal-parallax-links')) {
    customElements.define('horizontal-parallax-links', class extends HTMLElement {
      static loadGsap() {
        if (window.gsap) return Promise.resolve(window.gsap);
        if (!this.loading) {
          this.loading = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/gsap.min.js';
            script.onload = () => window.gsap ? resolve(window.gsap) : reject(new Error('Animation library unavailable'));
            script.onerror = () => reject(new Error('Animation library unavailable'));
            document.head.appendChild(script);
          }).catch(error => {
            this.loading = null;
            throw error;
          });
        }
        return this.loading;
      }
      async connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.ring = this.querySelector('.hp-ring');
        this.cards = Array.from(this.querySelectorAll('.hp-card'));
        if (!this.ring || !this.cards.length) return;
        const loadCardPhotos = () => {
          this.cards.forEach(card => {
            const photo = card.dataset.cardBackground;
            if (photo) {
              card.style.backgroundImage = 'url(' + JSON.stringify(photo) + ')';
              delete card.dataset.cardBackground;
            }
          });
          this.photoObserver?.disconnect();
        };
        this.photoObserver?.disconnect();
        if ('IntersectionObserver' in window) {
          this.photoObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) loadCardPhotos();
          }, { rootMargin: '100px 0px' });
          this.photoObserver.observe(this);
        } else {
          loadCardPhotos();
        }
        this.rotation = 180;
        this.targetRotation = 180;
        this.frame = 0;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.gsap = window.gsap || null;
        this.gesture = null;
        this.suppressClickUntil = 0;
        this.layout();
        this.startEntrance();
        window.addEventListener('resize', () => this.layout(), options);
        this.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch') return;
          if (event.button !== 0 || !event.isPrimary || this.cards.length < 2) return;
          if (event.target.closest('a, button, input, select, textarea')) return;
          if (!event.target.closest('.hp-card')) return;
          this.finish();
          this.gesture = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY,
            rotation: this.rotation,
            sensitivity: event.pointerType === 'mouse' ? 0.2 : 0.25,
            samples: [{ time: performance.now(), rotation: this.rotation }],
            moved: false
          };
        }, options);
        window.addEventListener('pointermove', event => {
          const gesture = this.gesture;
          if (!gesture || gesture.id !== event.pointerId) return;
          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;
          if (!gesture.moved) {
            if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
            if (event.pointerType !== 'mouse' && Math.abs(dy) > Math.abs(dx)) {
              this.finish();
              return;
            }
            gesture.moved = true;
            gesture.x = event.clientX;
            gesture.rotation = this.rotation;
            this.setAttribute('data-dragging', '');
            this.setPointerCapture(event.pointerId);
          }
          if (event.cancelable) event.preventDefault();
          this.targetRotation = gesture.rotation - (event.clientX - gesture.x) * gesture.sensitivity;
          this.recordMotion();
          this.requestFrame();
        }, { ...options, passive: false });
        window.addEventListener('pointerup', event => {
          if (this.gesture?.id === event.pointerId) this.release();
        }, options);
        window.addEventListener('pointercancel', event => {
          if (this.gesture?.id === event.pointerId) this.finish();
        }, options);
        this.addEventListener('touchstart', event => {
          if (event.touches.length !== 1 || this.cards.length < 2) {
            this.finish();
            return;
          }
          if (!event.target.closest('.hp-stage')) return;
          if (event.target.closest('input, select, textarea')) return;
          const touch = event.touches[0];
          this.finish();
          this.gesture = {
            touchId: touch.identifier,
            x: touch.clientX,
            y: touch.clientY,
            rotation: this.rotation,
            sensitivity: 0.25,
            samples: [{ time: performance.now(), rotation: this.rotation }],
            moved: false
          };
        }, { ...options, passive: true });
        this.addEventListener('touchmove', event => {
          const gesture = this.gesture;
          if (!gesture || gesture.touchId === undefined) return;
          if (event.touches.length !== 1) {
            this.finish();
            return;
          }
          const touch = Array.from(event.touches).find(item => item.identifier === gesture.touchId);
          if (!touch) return;
          const dx = touch.clientX - gesture.x;
          const dy = touch.clientY - gesture.y;
          if (!gesture.moved) {
            if (Math.max(Math.abs(dx), Math.abs(dy)) < 6) return;
            if (Math.abs(dy) >= Math.abs(dx)) {
              this.finish();
              return;
            }
            gesture.moved = true;
            gesture.x = touch.clientX;
            gesture.rotation = this.rotation;
            this.setAttribute('data-dragging', '');
          }
          if (event.cancelable) event.preventDefault();
          this.suppressClickUntil = performance.now() + 700;
          this.targetRotation = gesture.rotation - (touch.clientX - gesture.x) * gesture.sensitivity;
          this.recordMotion();
          this.requestFrame();
        }, { ...options, passive: false });
        const endTouch = event => {
          const gesture = this.gesture;
          if (!gesture || gesture.touchId === undefined) return;
          if (!Array.from(event.changedTouches).some(touch => touch.identifier === gesture.touchId)) return;
          if (gesture.moved) this.suppressClickUntil = performance.now() + 700;
          if (event.type === 'touchcancel') this.finish();
          else this.release();
        };
        this.addEventListener('touchend', endTouch, options);
        this.addEventListener('touchcancel', endTouch, options);
        this.addEventListener('click', event => {
          if (event.detail !== 0 && performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { ...options, capture: true });
        window.addEventListener('blur', () => this.finish(), options);
        this.addEventListener('lostpointercapture', event => {
          if (this.gesture?.id === event.pointerId) this.finish();
        }, options);
        this.addEventListener('focusin', event => {
          if (!event.target.matches(':focus-visible')) return;
          const index = this.cards.indexOf(event.target.closest('.hp-card'));
          if (index < 0) return;
          this.finish();
          this.rotation = index * 360 / this.cards.length;
          this.paint();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.indexOf(event.target.closest('.hp-card'));
          if (index < 0) return;
          this.finish();
          this.rotation = index * 360 / this.cards.length;
          this.paint();
        }, options);
        if (!this.gsap) {
          this.constructor.loadGsap().then(gsap => {
            if (options.signal.aborted || !this.isConnected) return;
            this.gsap = gsap;
            this.layout();
          }).catch(() => {});
        }
      }
      startEntrance() {
        if (!this.gsap || this.motion.matches) return;
        this.entrance = this.gsap.from(this.cards, {
          duration: 1.5,
          y: 200,
          opacity: 0,
          stagger: 0.1,
          ease: 'expo',
          onComplete: () => { this.entrance = null; }
        });
      }
      layout() {
        const radius = window.matchMedia('(min-width: 900px)').matches ? 650 : 500;
        this.cards.forEach((card, index) => {
          const single = this.cards.length === 1;
          if (this.gsap) {
            this.gsap.set(card, {
              rotationY: single ? 0 : -index * 360 / this.cards.length,
              transformOrigin: single ? '50% 50%' : `50% 50% ${radius}px`,
              z: single ? 0 : -radius
            });
          } else {
            card.style.transformOrigin = single ? '50% 50%' : `50% 50% ${radius}px`;
            card.style.transform = single ? 'none' : `translateZ(${-radius}px) rotateY(${-index * 360 / this.cards.length}deg)`;
          }
        });
        this.paint();
      }
      recordMotion() {
        const now = performance.now();
        const samples = this.gesture.samples;
        samples.push({ time: now, rotation: this.targetRotation });
        while (samples.length > 2 && samples[0].time < now - 90) samples.shift();
      }
      release() {
        const gesture = this.gesture;
        let speed = 0;
        if (gesture?.moved && !this.motion.matches) {
          const samples = gesture.samples;
          const first = samples[0];
          const last = samples[samples.length - 1];
          const duration = last.time - first.time;
          const idle = performance.now() - last.time;
          if (duration > 0 && idle < 100) {
            speed = (last.rotation - first.rotation) / duration;
            speed *= Math.max(0, 1 - idle / 100);
          }
        }
        this.finish();
        this.velocity = Math.max(-0.8, Math.min(0.8, speed));
        if (Math.abs(this.velocity) > 0.008) this.requestFrame();
      }
      requestFrame() {
        if (this.frame) return;
        this.frameTime = performance.now();
        this.frame = requestAnimationFrame(time => this.animate(time));
      }
      animate(time) {
        this.frame = 0;
        const elapsed = Math.min(40, Math.max(1, time - this.frameTime));
        this.frameTime = time;
        if (!this.gesture?.moved) {
          if (!this.velocity || this.motion.matches) {
            this.velocity = 0;
            return;
          }
          const decay = Math.exp(-elapsed / 650);
          this.rotation += this.velocity * 650 * (1 - decay);
          this.velocity *= decay;
          this.targetRotation = this.rotation;
          this.paint();
          if (Math.abs(this.velocity) > 0.008) {
            this.frame = requestAnimationFrame(nextTime => this.animate(nextTime));
          } else {
            this.velocity = 0;
          }
          return;
        }
        const difference = this.targetRotation - this.rotation;
        const blend = this.motion.matches ? 1 : 1 - Math.exp(-elapsed / 18);
        this.rotation += difference * blend;
        if (Math.abs(this.targetRotation - this.rotation) < 0.005) {
          this.rotation = this.targetRotation;
        }
        this.paint();
        if (this.rotation !== this.targetRotation) {
          this.frame = requestAnimationFrame(nextTime => this.animate(nextTime));
        }
      }
      paint() {
        const rotation = this.cards.length === 1 ? 0 : this.rotation;
        this.ring.style.transform = `rotateY(${rotation}deg)`;
      }
      finish() {
        const id = this.gesture?.id;
        this.gesture = null;
        this.velocity = 0;
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.targetRotation = this.rotation;
        this.removeAttribute('data-dragging');
        if (id !== undefined && this.hasPointerCapture(id)) this.releasePointerCapture(id);
      }
      disconnectedCallback() {
        this.photoObserver?.disconnect();
        this.finish();
        this.controller?.abort();
        this.entrance?.kill();
        this.entrance = null;
        if (this.gsap && this.ring) {
          this.gsap.killTweensOf(this.ring);
          this.gsap.killTweensOf(this.cards);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-parallax"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  if (window.VerticalParallaxWheelV3) {
    window.VerticalParallaxWheelV3.refresh();
    return;
  }

  const items = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  let rebuild = true;
  let keyboard = false;

  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

  const smooth = value => {
    value = clamp(value, 0, 1);
    return value * value * (3 - 2 * value);
  };

  const ready = image => image && image.complete && image.naturalWidth > 0;

  function schedule() {
    if (!frame && !document.hidden) {
      frame = requestAnimationFrame(paint);
    }
  }

  function refresh() {
    rebuild = true;
    schedule();
  }

  function clearBend(item) {
    item.stage.classList.remove('vp-bending');
    if (item.curve) item.curve.remove();
    item.curve = null;
    item.bands = [];
  }

  function collect() {
    rebuild = false;

    items.forEach((item, root) => {
      if (!root.isConnected) {
        item.observer.disconnect();
        clearBend(item);
        items.delete(root);
      }
    });

    document.querySelectorAll('[data-vp-section]').forEach(root => {
      if (items.has(root)) return;

      const stage = root.querySelector('.vp-stage');
      const face = root.querySelector('.vp-frame');

      if (!stage || !face) return;

      const item = {
        root,
        stage,
        face,
        bands: [],
        section: root.closest('.shopify-section') || root,
        image: face.querySelector('.vp-image')
      };

      item.observer = new ResizeObserver(schedule);
      item.observer.observe(face);
      items.set(root, item);
    });

    const bySection = new Map(
      Array.from(items.values(), item => [item.section, item])
    );

    items.forEach(item => {
      let first = item;
      let sibling = item.section.previousElementSibling;

      while (sibling) {
        const previous = bySection.get(sibling);

        if (previous && previous.root.dataset.effect === 'wheel') {
          first = previous;
        } else if (sibling.querySelector('[id^="TextButton-"]')) {
        } else if (sibling.offsetHeight) {
          break;
        }

        sibling = sibling.previousElementSibling;
      }

      item.leader = first;
    });
  }

  function wheelPose(offset, radius) {
    const angle = offset / radius;

    return {
      angle,
      y: radius * Math.sin(angle),
      z: radius * (Math.cos(angle) - 1)
    };
  }

  function surfaceRow(row, height, bend, angle, radius) {
    let y = row - height / 2;
    let z = 0;

    if (bend > 0.000001) {
      const curveRadius = height / (2 * bend);
      z = curveRadius * (Math.cos(y / curveRadius) - 1);
      y = curveRadius * Math.sin(y / curveRadius);
    }

    const c = Math.cos(angle);
    const s = Math.sin(angle);
    const screenY = radius * s + c * y + s * z;
    const screenZ = radius * (c - 1) - s * y + c * z;
    const scale = radius * 4 / (radius * 4 - screenZ);

    return {
      y: screenY * scale,
      scale
    };
  }

  function curveMatrix(rect, offset, length, vh, vw, bend, angle, radius) {
    const a = surfaceRow(offset, rect.height, bend, angle, radius);
    const b = surfaceRow(offset + length, rect.height, bend, angle, radius);
    const g = (a.scale / b.scale - 1) / length;
    const x0 = (vw / 2 - rect.left) * (1 - a.scale);
    const x1 = (vw / 2 - rect.left) * (1 - b.scale);
    const y0 = vh / 2 + a.y - rect.top;
    const y1 = vh / 2 + b.y - rect.top;
    const k = 1 + g * length;

    return [
      a.scale, 0, 0, 0,
      (x1 * k - x0) / length,
      (y1 * k - y0) / length,
      0, g,
      0, 0, 1, 0,
      x0, y0, 0, 1
    ];
  }

  function buildBend(item, rect, mobile) {
    clearBend(item);

    const curve = document.createElement('div');
    curve.className = 'vp-curve';
    curve.setAttribute('aria-hidden', 'true');
    curve.setAttribute('inert', '');

    const template = document.createElement('div');
    template.className = 'vp-bend-photo';
    template.style.width = rect.width + 'px';
    template.style.height = rect.height + 'px';

    const image = item.image.cloneNode(false);
    image.removeAttribute('id');
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.removeAttribute('loading');
    image.removeAttribute('fetchpriority');
    image.src = item.image.currentSrc || item.image.src;
    image.alt = '';
    template.appendChild(image);

    const shade = document.createElement('div');
    shade.className = 'vp-bend-shade';
    template.appendChild(shade);

    const count = mobile ? 24 : 36;
    const step = rect.height / count;

    for (let index = 0; index < count; index++) {
      const offset = index * step;
      const length = Math.min(step + 0.75, rect.height - offset);

      const band = document.createElement('div');
      band.className = 'vp-band';
      band.style.width = rect.width + 'px';
      band.style.height = length + 'px';

      const copy = template.cloneNode(true);
      copy.style.top = -offset + 'px';

      band.appendChild(copy);
      curve.appendChild(band);
      item.bands.push({
        node: band,
        offset,
        length
      });
    }

    curve.addEventListener('load', schedule, true);
    item.stage.appendChild(curve);
    item.curve = curve;
    item.key = [rect.width, rect.height, mobile, image.src].join('|');
  }

  function reset(item) {
    item.stage.style.removeProperty('perspective');
    item.stage.style.removeProperty('perspective-origin');
    item.face.style.removeProperty('transform');
    item.face.style.removeProperty('opacity');
    item.face.style.removeProperty('pointer-events');
    item.section.style.removeProperty('--vp-order');
    clearBend(item);
  }

  function paint() {
    frame = 0;

    if (rebuild) collect();

    const vw = document.documentElement.clientWidth;
    const vh = window.innerHeight;
    const mobile = vw < 750;

    if (!vw || !vh) return;

    items.forEach(({ root }) => {
      const full = root.dataset.fullWidth === 'true';
      const width = full ? vw + 'px' : '';

      if (root.style.width !== width) {
        root.style.width = width;
      }

      root.style.marginLeft = full
        ? 'calc(50% - ' + vw / 2 + 'px)'
        : '';
    });

    const readings = Array.from(items.values(), item => ({
      item,
      rect: item.stage.getBoundingClientRect()
    }));

    const radii = new Map();

    readings.forEach(({ item, rect }) => {
      if (item.root.dataset.effect !== 'wheel') return;

      const settings = item.leader.root.dataset;
      const strength = clamp(Number(settings.wheelStrength) || 0, 0, 12);

      let radius = vh * (
        1.15 - strength * 0.06 + (mobile ? 0.20 : 0)
      );

      if (mobile) {
        radius *= clamp(
          Number(settings.mobileWheelSize) || 85,
          70,
          120
        ) / 100;
      }

      radii.set(
        item.leader,
        Math.max(
          radii.get(item.leader) || 0,
          radius,
          rect.height * 0.95
        )
      );
    });

    readings.forEach(({ item, rect }) => {
      const root = item.root;
      const settings = item.leader.root.dataset;
      const effect = root.dataset.effect;

      const focused = keyboard &&
        item.face.contains(document.activeElement);

      const enabled = !reduced.matches && !focused;

      const wheel = enabled &&
        effect === 'wheel' &&
        Number(settings.wheelStrength) > 0 &&
        (!mobile || settings.rollMobile === 'true');

      const travel = enabled &&
        effect === 'vertical' &&
        !mobile
          ? rect.height * (Number(root.dataset.strength) || 0) / 100
          : 0;

      root.style.setProperty('--vp-travel', travel + 'px');

      const progress = clamp(
        (vh / 2 - rect.top - rect.height / 2) /
          ((vh + rect.height) / 2),
        -1,
        1
      );

      root.style.setProperty(
        '--vp-shift',
        (progress * travel * 0.95) + 'px'
      );

      if (!wheel || !rect.width || !rect.height) {
        reset(item);
        return;
      }

      const radius = radii.get(item.leader);
      const offset = rect.top + rect.height / 2 - vh / 2;
      const pose = wheelPose(offset, radius);
      const turn = Math.abs(pose.angle);

      if (turn >= 1.36) {
        reset(item);
        item.face.style.opacity = '0';
        item.face.style.pointerEvents = 'none';
        return;
      }

      const opacity = 1 - smooth((turn - 1.10) / 0.26);

      item.stage.style.perspective = (radius * 4) + 'px';

      item.stage.style.perspectiveOrigin =
        (vw / 2 - rect.left) + 'px ' +
        (vh / 2 - rect.top) + 'px';

      item.face.style.transform = Math.abs(offset) < 0.01
        ? 'none'
        : 'translate3d(0,' +
          (pose.y - offset) + 'px,' +
          pose.z + 'px) rotateX(' +
          (-pose.angle * 180 / Math.PI) + 'deg)';

      item.face.style.opacity = String(opacity);
      item.face.style.pointerEvents = opacity < 0.15 ? 'none' : 'auto';

      item.section.style.setProperty(
        '--vp-order',
        String(1 + Math.round(30 * Math.cos(pose.angle)))
      );

      const bend = (Number(settings.bendStrength) || 0) *
        0.025 *
        (mobile ? 0.70 : 1) *
        smooth((turn - 0.12) / 0.70);

      if (bend < 0.00001 || !ready(item.image)) {
        clearBend(item);
        return;
      }

      const key = [
        rect.width,
        rect.height,
        mobile,
        item.image.currentSrc || item.image.src
      ].join('|');

      if (!item.curve || item.key !== key) {
        buildBend(item, rect, mobile);
      }

      if (!Array.from(item.curve.querySelectorAll('img')).every(ready)) {
        item.stage.classList.remove('vp-bending');
        return;
      }

      item.curve.style.opacity = String(opacity);

      item.bands.forEach(band => {
        const matrix = curveMatrix(
          rect,
          band.offset,
          band.length,
          vh,
          vw,
          bend,
          pose.angle,
          radius
        );

        band.node.style.transform =
          'matrix3d(' + matrix.join(',') + ')';
      });

      item.stage.classList.add('vp-bending');
    });
  }

  window.VerticalParallaxWheelV3 = { refresh };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });

  [
    'shopify:section:load',
    'shopify:section:unload',
    'shopify:section:reorder'
  ].forEach(name => {
    document.addEventListener(name, refresh);
  });

  document.addEventListener('load', event => {
    if (
      event.target.matches &&
      event.target.matches('[data-vp-section] .vp-frame img')
    ) {
      schedule();
    }
  }, true);

  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);

  document.addEventListener('keydown', event => {
    if (event.key === 'Tab') {
      keyboard = true;
      schedule();
    }
  });

  document.addEventListener('pointerdown', () => {
    keyboard = false;
    schedule();
  }, { passive: true });

  reduced.addEventListener('change', schedule);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      cancelAnimationFrame(frame);
      frame = 0;
    } else {
      refresh();
    }
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      refresh,
      { once: true }
    );
  } else {
    refresh();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
